import clsx from 'clsx'

export type EventLogoVariant = 'topbar' | 'auth' | 'auth-compact'

/** Caixa fixa por superfície: a imagem escala com object-contain, sem crop. */
export const EVENT_LOGO_BOX_CLASS: Record<EventLogoVariant, string> = {
  // Topbar: 72/80px de altura — logo fica abaixo disso com respiro lateral.
  topbar: 'h-14 w-44 sm:h-16 sm:w-52',
  // Auth shell: logo é o sinal hero — caixa maior, full-bleed na coluna.
  auth: 'h-40 w-[min(100%,22rem)] sm:h-48 sm:w-[min(100%,24rem)]',
  // Sub-rotas: ainda em evidência, um degrau abaixo do hero de sign-in.
  'auth-compact': 'h-28 w-[min(100%,20rem)] sm:h-32 sm:w-[min(100%,22rem)]'
}

type EventLogoProps = {
  src: string
  alt?: string
  id?: string
  variant?: EventLogoVariant
  className?: string
}

export function EventLogo({
  src,
  alt = '',
  id,
  variant = 'topbar',
  className
}: EventLogoProps) {
  return (
    <span
      className={clsx(
        'inline-flex shrink-0 items-center justify-center',
        EVENT_LOGO_BOX_CLASS[variant],
        className
      )}
    >
      <img
        id={id}
        src={src}
        alt={alt}
        className="max-h-full max-w-full object-contain object-center"
      />
    </span>
  )
}
